import { AUTH_ROUTES } from '../../constants/_routes'
import auth_types from '../../constants/authTypes'
import { axios } from '../../services'
import { persist_user, login_success } from './login'

const reset_password_reset = () => {
  return {
    type: auth_types.RESET_PASSWORD.reset
  }
}

const reset_password_error = (message) => {
  return {
    type: auth_types.RESET_PASSWORD.error,
    payload: message
  }
}

const reset_password_request = () => {
  return {
    type: auth_types.RESET_PASSWORD.request
  }
}

const reset_password_success = () => {
  return {
    type: auth_types.RESET_PASSWORD.success
  }
}

const reset_password_failure = (messages) => {
  return {
    type: auth_types.RESET_PASSWORD.failure,
    payload: messages
  }
}

const reset_password = (resetData) => {
  return function (dispatch ) {
    // REQUEST
    dispatch(reset_password_request())

    const { password, password_confirmation, reset_password_token } = resetData
    axios(
      {
        url: AUTH_ROUTES.reset_password,
        method: 'PATCH',
        data: {
          user: {
            password: password,
            password_confirmation: password_confirmation,
            reset_password_token: reset_password_token
          }
        }
      }
    ).then( response => {
      // SUCCESS
      dispatch( reset_password_success( ) )
      if (response.data && response.data.business_active) {
        persist_user( response.data )
        dispatch( login_success( response ) )
        window.showSnackbar( 'success', "Your password has been successfully set." )
      } else {
        window.showSnackbar( 'warning', "Your password was successfully set, but the associated B2B account is inactive" )
      }

    }).catch( error => {
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else if (error.response && error.response.data) {
        errors = [error.response.data]
      } else {
        errors = ["Password reset request failed."]
      }
      // FAILURE
      dispatch( reset_password_failure( errors ) )
    })
  }

}

export {
  reset_password,
  reset_password_error,
  reset_password_reset
}



// WEBPACK FOOTER //
// ./src/js/actions/auth/reset_password.js